module.exports = __webpack_public_path__ + "static/media/ru.e3ee3b09.svg";